import React from 'react';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { navigateTo } from '../../redux/actions';
import { baseStyles } from '../../theme/style';

export default function MyLink({ pathname, onClick = () => {}, state = null, children }) {
  const dispatch = useDispatch();
  const [isHover, setIsHover] = useState(false);

  const handeClick = (e) => {
    if (!onClick) return;
    onClick();
    dispatch(navigateTo(pathname, state));
  };
  const getStyle = () => {
    return isHover ? baseStyles.linkHover : baseStyles.link;
  };
  return (
    <div onMouseLeave={() => setIsHover(false)} onMouseEnter={() => setIsHover(true)} onClick={handeClick} style={getStyle()}>
      {children}
    </div>
  );
}
